import { sortBy } from 'lodash'

const initialState = {
    ui: {
      loading: true
    },
    recurringCharges: []
  }

export default function recurringCharges(state = initialState, action){
  switch (action.type) {
    case "UPDATE_RECURRING_CHARGES_UI":
     return {
        ...state,
        ui: {
          ...state.ui,
          ...action.payload,
        }
     }
    case "ADD_RECURRING_CHARGE":
      return {
        ...state,
        recurringCharges: sortBy([
          action.payload,
          ...state.recurringCharges,
        ], (obj)=>(new Date(obj.next_payment_charged_on))),
      }
    case "SUCCESS_FETCH_RECURRING_CHARGES":
      return {
        ...state,
        recurringCharges: action.payload//sortBy(action.payload, (obj)=>(new Date(obj.next_payment_charged_on))),
      }
    default:
      return state;
  }
} 